import {
  Button,
  Paper,
} from '@mui/material';
import React from 'react';
import { Box } from '@mui/system';
import Layout from 'components/Layout';
import Overlay from 'components/Overlay';
import { HEADER_HEIGHT } from 'constants';
import Filters from './Filters';
import MapView from './MapView';
import MerchantCard from './MerchantCard';

function MerchantsMapMobile({
  merchants, filters, setFilters, center,
  selectedMerchant, setSelectedMerchant,
  loading,
}) {
  return (
    <Layout
      header={(
        <Layout.Header
          visibleElements={[
            Layout.Header.Elements.LOGO,
          ]}
        />
      )}
      footer={null}
    >
      <Box display="flex" flexDirection="column" height={`calc(100vh - (${HEADER_HEIGHT}px + var(--gap-top)))`}>
        <Filters
          value={filters}
          onChange={setFilters}
          pt={0}
        />
        <MapView
          merchants={merchants}
          center={center}
          selectedMerchant={selectedMerchant}
          setSelectedMerchant={setSelectedMerchant}
          height="100%"
        />
      </Box>

      <Overlay
        hideBackdrop
        open={Boolean(selectedMerchant)}
        hideIndicator
        onClose={() => {
          setSelectedMerchant(null);
        }}
        sx={{
          top: '100%',
          '& .MuiBackdrop-root': {
            backdropFilter: 'none',
            bgcolor: '#00000020',
          },
          '& .MuiDrawer-paper': {
            overflow: 'visible',
            transition: 'top 0.3s ease-out',
          },
        }}
      >
        <Overlay.Content
          sx={{ p: 0, overflow: 'visible' }}
        >
          <Box
            sx={{
              position: 'absolute',
              width: '100%',
              P: 1,
              top: -55,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Button
              size="small"
              onClick={() => setSelectedMerchant(null)}
              variant="muted"
              sx={{
                opacity: selectedMerchant ? 1 : 0,
              }}
            >
              Show other locations
            </Button>
          </Box>
          <MerchantCard
            merchant={selectedMerchant}
            variant="default"
          />
        </Overlay.Content>
      </Overlay>
    </Layout>
  );
}

export default MerchantsMapMobile;
